import { Dispatch, Key } from 'react';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import { SearchOutlined } from '@ant-design/icons';

import FilterDropdown from '../FilterDropdown';

export const getFilterProps = <RecordType extends Record<string, any>>(
  dataIndex: string,
  setSearchText: Dispatch<Key>,
  setSearchedColumn: Dispatch<Key>,
  searchedColumn: Key,
  searchText?: Key,
) => ({
  filterDropdown: (props: FilterDropdownProps) => (
    <FilterDropdown
      {...{ dataIndex, setSearchText, setSearchedColumn, ...props }}
    />
  ),
  onFilter: (value: Key | boolean, record: RecordType) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toString().toLowerCase()),

  render: (text: any) =>
    searchedColumn === dataIndex && searchText ? (
      <span
        dangerouslySetInnerHTML={{
          __html: text
            .toString()
            .replace(
              new RegExp(searchText.toString(), 'gi'),
              (match: string) =>
                `<mark style="background-color: #ffc069; padding: 0">${match}</mark>`,
            ),
        }}
      />
    ) : (
      text
    ),
  filterIcon: <SearchOutlined />,
});
